// extracted by mini-css-extract-plugin
export default {"data":"VideoAI_data__x2Vme","filter":"VideoAI_filter__kP-ja","label":"VideoAI_label__eYbKI"};